var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoLabel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-labels"
  }, /*#__PURE__*/React.createElement("g", {
    id: "label"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M40.8421 15.3333C41.8568 15.3333 42.7552 15.8742 43.3001 16.6889L53.5903 32L43.2975 47.3149C42.7552 48.1258 41.8568 48.6667 40.844 48.6667L13.0526 48.64C12.2226 48.64 11.4738 48.2759 10.9292 47.7039C10.3515 47.0972 10 46.2575 10 45.3333V18.6667C10 17.7425 10.3515 16.9028 10.9292 16.2961C11.4738 15.7241 12.2226 15.36 13.0546 15.36L40.8421 15.3333Z",
    stroke: "#D1D5DB",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoLabel);
export default __webpack_public_path__ + "static/media/icon-no-label.61c370c3709f03674b1388a2595b754b.svg";
export { ForwardRef as ReactComponent };